import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { MatchType } from "../components/MatchHeaderDropdown";
import { answerInterface } from "../components/segments/QuestionSegment";
import { QuestionType, QuestionTypeName } from "../types/type";
import moment from "moment";
import { captureException, captureMessage } from "@sentry/react";
import { getRank, storeRank, storeTotalPoint } from "../config/UserStorer";

let logToSentryManually = false;
let logApiCallTime = true;

export interface UserPick {
  user_mid: number;
  start_time: string;
  away_team_abbreviation: string;
  home_team_abbreviation: string;
  question_mid: number;
  is_over: boolean;
  benchmark_value: number;
  actual_value: number;
  response_time_ms: number;
  match_mid: number;
  question_type_name: QuestionTypeName;
  home_team_logo_url: string;
  away_team_logo_url: string;
}
export interface RankedUser {
  user_mid: number;
  email: string;
  username: string;
  rank: number;
  points: number;
  response_time_total: number;
}
export interface UserInformationType {
  mamba_id: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  points: number;
}
export interface LeaderBoardResponse {
  ranked_users: RankedUser[];
}
export interface MyRanking {
  user_mid: number;
  weekly_rank: number;
  accumulated_rank: number;
  user_count: number;
}
export interface userPoint {
  user_mid: number;
  weekly_points: number;
  total_points: number;
}
export interface UserCount {
  user_count: number;
  weekly_user_count: number;
}
export interface UserPicksListResponse {
  user_picks_list: UserPick[];
}
export interface SubmitAnswersRequestBody {
  question_response_list: answerInterface[];
}

export interface SubmitAnswersResponse {
  ok: boolean;
  message: string;
}
class AuthService {
  private axiosInstance: AxiosInstance;
  private cookie = document.cookie;
  private Url: string = "https://ajio.api.bettorlook.com/ajio/";
  constructor() {
    this.axiosInstance = axios.create();
    this.addInterceptors();
  }

  private addInterceptors() {
    this.axiosInstance.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        const token = localStorage.getItem("ajio_access_token");

        if (token) {
          config.headers.Authorization = token;
        }
        return config;
      },
      (error: any) => {
        return Promise.reject(error);
      }
    );
  }

  async registerNewUser(
    username: string,
    firstName: string,
    lastName: string,
    email: string
  ) {
    const startTime = new Date().getTime();
    try {
      const response = await this.axiosInstance.post(
        "https://ajio.api.bettorlook.com/ajio/user_profile/register_new_user",
        {
          username,
          first_name: firstName,
          last_name: lastName,
          email,
        }
      );
      const endTime = new Date().getTime(); // get end time in milliseconds
      const elapsedTime = endTime - startTime; // calculate time difference
      console.log("response", response);
      const userToken = this.getUserTokenFromResponseCookie(response.headers);
      console.log("userToken", userToken);
      if (userToken) {
        localStorage.setItem("userToken", userToken);
      }
      // log elapsed time to Sentry

      return response.data;
    } catch (error: any) {
      {
        logToSentryManually &&
          captureException(error.message + " ,  registering new user");
      }
      throw new Error(error.message);
    }
  }
  async userPoint() {
    try {
      const response = await this.axiosInstance.get(
        "https://ajio.api.bettorlook.com/ajio/user_profile/user_points"
      );
      let responseData = response.data as userPoint;
      storeTotalPoint(
        JSON.stringify({
          total: responseData.total_points,
          weeklytotal: responseData.weekly_points,
        })
      );
    } catch (error: any) {
      throw new Error(error.message);
    }
  }

  async getExistingUser(
    username: string,
    firstName: string,
    lastName: string,
    email: string
  ) {
    const startTime = new Date().getTime();
    try {
      const response = await this.axiosInstance.post(
        "https://ajio.api.bettorlook.com/ajio/user_profile/get_existing_user_token  ",
        {
          username,
          first_name: firstName,
          last_name: lastName,
          email,
        }
      );
      const endTime = new Date().getTime();
      const elapsedTime = endTime - startTime;

      const userToken = this.getUserTokenFromResponseCookie(response.headers);
      console.log("userToken", userToken);
      if (userToken) {
        localStorage.setItem("userToken", userToken);
      }

      return response.data;
    } catch (error: any) {
      {
        logToSentryManually &&
          captureException(error.message + " , getting existing user");
      }
      throw new Error(error.message);
    }
  }
  async loadAvailableMatches() {
    const startTime = new Date().getTime();
    try {
      const response = await this.axiosInstance.get(
        // localStorage.getItem("ajio_access_token") === null
        //   ? this.Url + "guest/game_data/upcoming_matches"
        this.Url + "game_data/upcoming_matches"
      );

      if (!response.status) {
        {
          logToSentryManually &&
            captureException(
              "Network response was not ok" + ", loading available matches"
            );
        }
        throw new Error("Network response was not ok");
      }
      // this.loadAvailableMatches();
      const responseData = (await response.data) as { match_list: MatchType[] };
      // if (responseData) {
      // this.loadAvailableMatches();
      // }
      let resp = responseData.match_list.filter((a) => {
        return (
          moment(a.start_time + "Z").diff(moment(), "hours") <= 48 &&
          moment(a.start_time + "Z").diff(moment(), "minute") > 0
        );
      });

      const endTime = new Date().getTime();
      const elapsedTime = endTime - startTime;

      return resp.sort((a: MatchType, b: MatchType) => {
        return moment(a.start_time).diff(moment(b.start_time));
      });
    } catch (error: any) {
      {
        logToSentryManually &&
          captureException(error.message + " , loading available users");
      }
      throw new Error(error.message);
    }
  }
  async userCountCalculator() {
    const startTime = new Date().getTime();
    try {
      const response = await this.axiosInstance.get(
        this.Url + "game_data/user_count"
      );
      if (!response.status) {
        {
          logToSentryManually &&
            captureException(
              "Network response was not ok" + ", user count calculator"
            );
        }
        throw new Error("Network response was not ok");
      }
      // this.loadMyData();
      const responseData = await response.data;
      console.log("user_count", responseData);
      const endTime = new Date().getTime();
      const elapsedTime = endTime - startTime;

      return responseData as UserCount;
    } catch (error: any) {
      {
        logToSentryManually &&
          captureException(error.message + " , user count calculator");
      }
      throw new Error(error.message);
    }
  }
  filterGamesByDate(games: MatchType[], date: string) {
    const dayOfWeek = moment(date).format("dddd");
    const today = moment(date).startOf("day");
    const tomorrow = moment(date).add(1, "day").startOf("day");
    const afterTomorrow = moment(date).add(2, "day").startOf("day");

    let filteredGames = games.filter(
      (game) =>
        moment(game.start_time + "Z").isSame(today, "day") ||
        moment(game.start_time + "Z").isSame(tomorrow, "day") ||
        (dayOfWeek === "Friday" &&
          moment(game.start_time + "Z").isBetween(tomorrow, afterTomorrow)) ||
        (dayOfWeek === "Saturday" &&
          moment(game.start_time + "Z").isSameOrAfter(tomorrow)) ||
        (dayOfWeek === "Sunday" &&
          moment(game.start_time + "Z").isSameOrAfter(tomorrow) &&
          moment(game.start_time + "Z").isBefore(afterTomorrow))
    );

    if (dayOfWeek === "Friday" && filteredGames.length === 3) {
      const lastGameEndTime = moment(filteredGames[2].start_time + "Z").add(
        1,
        "minutes"
      );
      const afterLastGame = moment(filteredGames[2].start_time + "Z")
        .add(1, "day")
        .startOf("day");

      filteredGames = filteredGames.concat(
        games.filter(
          (game) =>
            moment(game.start_time + "Z").isBetween(
              lastGameEndTime,
              afterLastGame
            ) && !filteredGames.includes(game)
        )
      );
    } else if (filteredGames.length <= 1) {
      const nextDay = moment(date).add(1, "day").startOf("day");
      const nextDayGames = games.filter(
        (game) =>
          moment(game.start_time + "Z").isSame(nextDay, "day") &&
          !filteredGames.includes(game)
      );
      const numGamesToAdd = 2 - filteredGames.length;

      filteredGames = filteredGames.concat(
        nextDayGames.slice(0, numGamesToAdd)
      );
    }

    return filteredGames;
  }

  async loadMyData() {
    const startTime = new Date().getTime();
    try {
      const response = await this.axiosInstance.get(
        "https://ajio.api.bettorlook.com/ajio/user_profile/me"
      );
      if (!response.status) {
        {
          logToSentryManually &&
            captureException(
              "Network response was not ok" + ", loading user data"
            );
        }
        throw new Error("Network response was not ok");
      }
      // this.loadMyData();
      const responseData = await response.data;
      console.log("responseData_user", responseData);

      const endTime = new Date().getTime();
      const elapsedTime = endTime - startTime;

      return responseData as UserInformationType;
    } catch (error: any) {
      {
        logToSentryManually &&
          captureException(error.message + " , loading user data");
      }
      throw new Error(error.message);
    }
  }
  async loadQuestions(matchId: number | undefined): Promise<QuestionType[]> {
    const startTime = new Date().getTime();
    try {
      const response = await this.axiosInstance.get(
        "https://ajio.api.bettorlook.com/ajio/questions/question_set/" + matchId
      );
      console.log("responses.data", response.data.question_list);

      const endTime = new Date().getTime();
      const elapsedTime = endTime - startTime;

      return response.data.question_list;
    } catch (error: any) {
      {
        logToSentryManually &&
          captureException(error.message + " , loading questions");
      }
      throw new Error(error.message);
    }
  }
  async getUserPicksList(): Promise<UserPicksListResponse> {
    const startTime = new Date().getTime();
    try {
      const response = await this.axiosInstance.get(
        "https://ajio.api.bettorlook.com/ajio/game_data/my_picks"
      );

      if (!response.status) {
        captureException(
          `HTTP error! status: ${response.status} , getting user pick list`
        );
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.data;

      const endTime = new Date().getTime();
      const elapsedTime = endTime - startTime;

      return data as UserPicksListResponse;
    } catch (error: any) {
      {
        logToSentryManually &&
          captureException(error.message + " , getting user pick list");
      }
      throw new Error(`Error: ${error.message}`);
    }
  }
  async submitAnswers(
    requestBody: SubmitAnswersRequestBody
  ): Promise<SubmitAnswersResponse> {
    const startTime = new Date().getTime();
    console.log("requestBody", requestBody);
    try {
      const response = await this.axiosInstance.post(
        "https://ajio.api.bettorlook.com/ajio/questions/submit_answers",
        { question_response_list: requestBody.question_response_list }
      );

      if (!response.status) {
        {
          logToSentryManually &&
            captureException(
              `HTTP error! status: ${response.status} , submitting answer`
            );
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.data;
      console.log("AnswerLog", data);

      const endTime = new Date().getTime();
      const elapsedTime = endTime - startTime;

      return data as SubmitAnswersResponse;
    } catch (error: any) {
      {
        logToSentryManually &&
          captureException(error.message + " , submitting answer");
      }
      throw new Error(`Error: ${error.message}`);
    }
  }
  async getLeaderBoard(
    isWeekly: boolean,
    offset: number,
    limit: number
  ): Promise<LeaderBoardResponse> {
    console.log("i was here_2", isWeekly);
    if (localStorage.getItem("ajio_access_token") !== null) {
      const startTime = new Date().getTime();
      try {
        const response = await this.axiosInstance.get(
          `https://ajio.api.bettorlook.com/ajio/game_data/${
            isWeekly ? "weekly_leader_board" : "accumulated_leader_board"
          }/${offset}/40`
        );

        if (!response.status) {
          {
            logToSentryManually &&
              captureException(
                `HTTP error! status: ${response.status} , getting leaderboard`
              );
          }
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.data;
        console.log("data", data);

        const endTime = new Date().getTime();
        const elapsedTime = endTime - startTime;

        return data as LeaderBoardResponse;
      } catch (error: any) {
        {
          logToSentryManually &&
            captureException(error.message + " , getting leaderboard");
        }
        throw new Error(`Error: ${error.message}`);
      }
    } else {
      return { ranked_users: [] };
    }
  }

  async loadMyRank(): Promise<MyRanking> {
    const startTime = new Date().getTime();
    try {
      const response = await this.axiosInstance.get(
        `https://ajio.api.bettorlook.com/ajio/user_profile/get_user_rankings`
      );

      if (response.status > 200) {
        {
          logToSentryManually &&
            captureException(
              `HTTP error! status: ${response.status} , loading user rank`
            );
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.data;
      console.log("data", data);

      const endTime = new Date().getTime();
      const elapsedTime = endTime - startTime;

      return data as MyRanking;
    } catch (error: any) {
      if (getRank() === null) {
        let resp: MyRanking = {
          user_mid: 0,
          weekly_rank: 0,
          accumulated_rank: 0,
          user_count: 1,
        };
        return resp;
      } else {
        throw new Error(`Error: ${error.message}`);
      }
    }
  }

  async registerWithFetch(
    username: string,
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string
  ) {
    const startTime = new Date().getTime();
    try {
      const response = await fetch(
        "https://ajio.api.bettorlook.com/ajio/user_profile/register_new_user",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username,
            first_name: firstName,
            last_name: lastName,
            email,
            phone_number: phoneNumber,
          }),
        }
      );
      console.log(
        "response_authorization",
        response.headers.get("authorization")
      );
      if (response.headers.get("authorization")) {
        localStorage.setItem(
          "ajio_access_token",
          response.headers.get("authorization") + ""
        );
      }

      console.log("response", response.headers);
      let responseData: Response;

      if (!response.ok) {
        console.log("error", response);
        {
          logToSentryManually &&
            captureException(
              "Network response was not ok " +
                response.statusText +
                ", registering with fetch"
            );
        }
        throw new Error("Network response was not ok" + response.statusText);
      } else {
      }
      responseData = await response.json();
      console.log("responseData", responseData);

      const userToken = this.getUserTokenFromResponseCookie(response.headers);
      console.log("userToken", userToken);
      if (userToken) {
        localStorage.setItem("userToken", userToken);
      }

      const endTime = new Date().getTime();
      const elapsedTime = endTime - startTime;

      {
        logApiCallTime &&
          elapsedTime > 1000 &&
          captureMessage(
            `API call took ${elapsedTime}ms , registering with fetch`
          );
      }

      return responseData;
    } catch (error: any) {
      {
        logToSentryManually &&
          captureException(error.message + " , registering with fetch");
      }
      throw new Error(error.message);
    }
  }

  private getUserTokenFromResponseCookie(headers: any) {
    const cookies = headers["set-cookie"];
    console.log("cookies", headers);
    if (cookies) {
      for (let cookie of cookies) {
        const match = cookie.match(/ajio_access_token=([^;]+)/);
        if (match) {
          return match[1];
        }
      }
    }
    return null;
  }
  storageAvailable(type: "localStorage" | "sessionStorage"): boolean {
    let storage;
    try {
      storage = window[type];
      const x = "__storage_test__";
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return false;
    }
  }
}

export default AuthService;
